import { LOCATION_FALLBACK_PUERTA_DEL_SOL } from "../config/constants";
import { RegisterUserForm } from "../interfaces";


export const registerUserFormAdapter = (formValue: RegisterUserForm): any => {
  console.log("RegisterUserformValueAdapter", formValue);
  
  const payload: any = {
    startDate: formValue.startDate,
    endDate: formValue.endDate,
    startLocation: formValue.startLocationAddress ?? LOCATION_FALLBACK_PUERTA_DEL_SOL.address,
    endLocation: formValue.endLocation,
    tripType: Array(String(formValue.tripType)),
    interests: (formValue.interestIdList as unknown as number[]).map((interest: number) => String(interest)),
    transportMeans: (formValue.transportMeans as unknown as string[]).map((transport: string) => String(transport)),
    maxDistanceWalking: formValue.maxDistanceWalking,
    geolocation: formValue.geolocation,
    subdomain: formValue.subdomain,
    app: formValue.subdomain,
    coordinates: `${formValue.startLocationLat ?? LOCATION_FALLBACK_PUERTA_DEL_SOL.lat}` + "," + `${formValue.startLocationLng ?? LOCATION_FALLBACK_PUERTA_DEL_SOL.lng}`,
  }
  
  // optional fields: startTime, endTime & movilityType: if they are falsy, they will not be included in the payload
  if (formValue.startTime) {
    payload.startTime = formValue.startTime;
  }
  if (formValue.endTime) {
    payload.endTime = formValue.endTime;
  }
  if (formValue.movilityType) {
    payload.movilityType = formValue.movilityType;
  }
  
  return payload;
};